const detectBrowserPlatform = (): string => {
  if (typeof navigator === 'undefined') {
    return 'darwin'
  }
  const ua = navigator.userAgent
  if (/Android/i.test(ua)) return 'android'
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  if (ua.includes('Windows')) return 'win32'
  if (ua.includes('Linux')) return 'linux'
  return 'darwin'
}

const runtimePlatform =
  typeof process !== 'undefined' && typeof process.platform === 'string' ? process.platform : detectBrowserPlatform()

const computeIsDev = (): boolean => {
  // For browser builds, Vite's define replaces process.env.NODE_ENV at build time.
  // For Electron (main + renderer), process.env.NODE_ENV is available at runtime.
  return process.env.NODE_ENV === 'development'
}

export const isWindows = runtimePlatform === 'win32'
export const isMac = runtimePlatform === 'darwin'
export const isDev = computeIsDev()
